module.exports = __webpack_public_path__ + "static/img/s41.44d9434b.png";